import React from 'react';

const Submit = () => {
    return (
        <div>
            <p className="text-3xl text-gray-700 font-baskerville">Submit</p>
            <p className="mt-2 text-gray-500">
                Thank you for filling out your information! Go ahead and submit
                your profile and go to your dashboard.
            </p>
        </div>
    );
};

export default Submit;
